<template>
    <div class="page-header">
      <v-container style="padding: 0px;">
        <v-row justify="space-between" no-gutters>
          <v-col cols="5" no-gutters class="d-flex py-3 px-3">
            <!-- Button for Telephone -->
            <a
              href="tel:+441156786278"
              class="d-flex contact-link align-items-center mr-6"
            >
              <img
                class="logo mr-2"
                src="/static/icons/call-improve-microlearning-platform.png"
                style="height: 20px; width: 20px; padding: 0px;"
                alt="Call Improve"
              />
              <span class="header-contact-link">0115 6786278</span>
            </a>
            <!-- Button for Email -->
            <a
              id="email-link"
              href="mailto:hello@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20..."
              class="d-flex contact-link align-items-center"
            >
              <img
                class="logo mr-2"
                src="/static/icons/email-improve-microlearning-platform.png"
                style="height: 20px; width: 28px; padding: 0px;"
                alt="Email Improve"
              />
              <span class="header-contact-link">hello@improve.online</span>
            </a>
          </v-col>
  
          <v-col cols="7" no-gutters class="d-flex justify-end">
            <div id="top-header" class="py-3">
              <a
                text
                :href="this.frontEndUrl + '/about-us'"
                class="mr-2 ml-2 fw-normal"
                style="font-size: 14px;"
                >About Us</a
              >|
              <a
                text
                :href="this.frontEndUrl + '/partner-programme'"
                class="mr-2 ml-2 fw-normal"
                style="font-size: 14px;"
                >Partner Programme</a
              >|
              <a
                text
                :href="this.frontEndUrl + '/blog'"
                class="mr-2 ml-2 fw-normal"
                style="font-size: 14px;"
                >Blog</a
              >
            </div>
            <a
              class="login-base-btn login-btn"
              :href="this.directUrl + '/#/login'"
              color="primary"
              >Login</a
            >
            <a
              class="login-base-btn partner-login-btn"
              :href="this.partnerUrl"
              color="success"
              >Partner Login</a
            >
          </v-col>
        </v-row>
      </v-container>
      <hr />
      <v-container style="padding: 0px 15px">
        <v-row>
          <v-col cols="3">
            <a :href="this.frontEndUrl + '/homepage'" class="logo-anchor"
              ><img class="logo" src="/static/logo.png"
            /></a>
          </v-col>
          <v-col cols="9" class="text-right">
            <v-toolbar class="main-menu menu-desktop-view ">
              <v-toolbar-items
                class="justify-end d-flex align-items-center justify-end"
              >
                <v-btn class="main-menu-item" text :href="this.frontEndUrl +'/why-improve'"
                  >Why IMPROVE?</v-btn
                >
                <v-btn class="main-menu-item" text :href="this.frontEndUrl + '/features'">Features</v-btn>
                <v-btn
                  class="main-menu-item desktop-course-library"
                  text
                  :href="this.frontEndUrl + '/course-library'"
                  >Course Library
                </v-btn>
                <!--<div
                  class="desktop-course-library-hidden"
                  style="position: relative;"
                >
                  <div class="desktop-dropdown-menu">
                    <div class="desktop-dropdown-menu-item">
                      <a :href="this.directUrl + '/#/courses/cyber-security'">Cyber Security</a>
                    </div>
                  </div>
                </div>-->
                <v-btn class="main-menu-item" text :href="this.frontEndUrl + '/pricing'">Pricing</v-btn>
               
                <v-btn class="main-menu-item" text :href="this.frontEndUrl +'/contact'"
                  >Get in touch</v-btn
                >
                <a
                  :href="this.directUrl + '/#/signup?ref=website'"
                  class="request-demo-btn ml-3 d-flex align-self-center"
                  >Free Trial</a
                >
              </v-toolbar-items>
            </v-toolbar>
            <header class="header menu-tablet-view ">
              <input class="menu-btn" type="checkbox" id="menu-btn" />
              <label class="menu-icon" for="menu-btn"
                ><span class="navicon"></span
              ></label>
              <ul class="menu">
                <li>
                  <a :href="this.frontEndUrl +'/why-improve'"><span>Why IMPROVE?</span></a>
                </li>
                <li>
                  <a :href="this.frontEndUrl + '/features'"><span>Features</span></a>
                </li>
                <li class="tablet-course-library">
                  <a :href="this.frontEndUrl +'/course-library'"><span>Course Library</span></a>
                  <!-- <div class="tablet-course-library-hidden">
                    <div class="tablet-dropdown-menu-item">
                      <a :href="this.frontEndUrl + '/courses/cyber-security'">Cyber Security</a>
                    </div> 
                  </div>-->
                </li>
                <li>
                  <a :href="this.frontEndUrl +'/pricing'"><span>Pricing</span></a>
                </li>
                <li>
                  <a :href="this.frontEndUrl+'/contact'"><span>Get in touch</span></a>
                </li>
                <li>
                  <a v-bind:href="getReferralID"><span>Free Trial</span></a>
                </li>
              </ul>
            </header>
            <header class="header menu-mobile-view">
              <input class="menu-btn2" type="checkbox" id="menu-btn2" />
              <label class="menu-icon" for="menu-btn2"
                ><span class="navicon"></span
              ></label>
              <ul class="menu">
                <li>
                  <a :href="this.frontEndUrl +'/why-improve'"><span>Why IMPROVE?</span></a>
                </li>
                <li>
                  <a :href="this.frontEndUrl + '/features'"><span>Features</span></a>
                </li>
                <li class="mobile-course-library">
                  <a :href="this.frontEndUrl +'/course-library'"><span>Course Library</span></a>
                  <!--<div class="mobile-course-library-hidden">
                    <div class="mobile-dropdown-menu-item">
                      <a :href="this.frontEndUrl + '/courses/cyber-security'">Cyber Security</a>
                    </div>
                  </div>-->
                </li>
                <li>
                  <a :href="this.frontEndUrl +'/pricing'"><span>Pricing</span></a>
                </li>
                <li>
                  <a :href="this.frontEndUrl+'/contact'"><span>Get in touch</span></a>
                </li>
                <li>
                  <a v-bind:href="getReferralID"><span>Free Trial</span></a>
                </li>
              </ul>
            </header>
          </v-col>
        </v-row>
      </v-container>
  
      <div class="benefits-bar">
        <v-container style="padding:0px 15px;">
          <div class="d-flex">
            <v-col class="benefit-item">
              <img
                class="logo mr-2"
                src="/static/icons/benefits/improve-people-development-solution.png"
                style="height: 15px; width: 20px; padding: 0px;"
                alt="People Development"
              />
              <span>24/7 ACCESS TO COURSES</span>
            </v-col>
            <v-col class="benefit-item">
              <img
                class="logo mr-2"
                src="/static/icons/benefits/integration-support-icon.png"
                style="height: 18px; width: 18px; padding: 0px;"
                alt="Integration Support"
              />
              <span>HR APP INTEGRATIONS</span></v-col
            >
            <v-col class="benefit-item">
              <img
                class="logo mr-2"
                src="/static/icons/benefits/induction-training-software-for-businesses.png"
                style="height: 18px; width: 18px; padding: 0px;"
                alt="Induction training"
              />
              <span>14 DAY FREE TRIAL</span></v-col
            >
            <v-col class="benefit-item">
              <img
                class="logo mr-2"
                src="/static/icons/benefits/improves-microlearning-courses.png"
                style="height: 15px; width: 15px; padding: 0px;"
                alt="120+ Microlearning Courses"
              />
              <span>120+ MICROLEARNING COURSES</span></v-col
            >
            <v-col id="mc-benefit" class="benefit-item">
              <img
                class="logo mr-2"
                src="/static/icons/benefits/compliance-management-for-businesses.png"
                style="height: 17px;width: 12px; padding: 0px;"
                alt="Complance Management"
              />
              <span>COMPLIANCE MANAGEMENT</span></v-col
            >
          </div>
        </v-container>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "SuperAdminNavigation",
    props:{
      frontEndUrl: String,
      directUrl: String,
      partnerUrl: String
    },
    computed: {
      currentRouteName() {
        return this.$route.name;
      },
      getReferralID: function() {
        if (
          localStorage.getItem('refID') != null ||
          localStorage.getItem('refID') != undefined
        ) {
          return (
            'https://app.improve.online/#/signup?ref=website&afi=' +
            localStorage.getItem('refID')
          );
        } else {
          return 'https://app.improve.online/#/signup?ref=website';
        }
      },
    },
  };
  </script>

<style>
  .page-header .d-flex {
    flex-direction: unset;
  }

  .page-header .menu-mobile-view span {
    color: #333333;
  }

  .page-header .menu-mobile-view a {
    padding: 10px 0px !important;
    border-right: none;
  }
</style>
